var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
// eslint-disable-next-line max-classes-per-file
import { injectable } from 'inversify';
import { Transform } from 'class-transformer';
import { Calendar } from '../calendar';
import { IsFilters } from './is-filters.validator';
import { filtersTransform } from './filters.transform';
let FilterService = class FilterService {
    constructor(calendar) {
        this.calendar = calendar;
    }
    /**
     * Возвращает новый класс с фильтрами
     * Расширяющая часть описана типом {@link FiltersClass}
     *
     * @typeParam T - Класс, который будет расширен
     * @param Dto - Расширяемый класс
     * @param filters - Фильтры
     * @returns Новый класс с фильтрами
     */
    buildDto(Dto, filters) {
        class FiltersDto extends Dto {
        }
        __decorate([
            Transform(filtersTransform(filters)),
            IsFilters(filters),
            __metadata("design:type", Object)
        ], FiltersDto.prototype, "filters", void 0);
        return FiltersDto;
    }
    /**
     * Преобразует даты начала и окончания для Dateable значения без из строки в дату
     * Если значение имеет тип отличный от Dateable, то никаких изменений не вносится
     *
     * @param value - Преобразуемое значение
     */
    sanitizeStringToDate(value) {
        var _a;
        if (typeof value !== 'object' ||
            Array.isArray(value) ||
            !((_a = value.start) !== null && _a !== void 0 ? _a : value.end)) {
            return;
        }
        if (value.start) {
            value.start = new Date(value.start);
        }
        if (value.end) {
            value.end = new Date(value.end);
        }
    }
    /** Преобразует строковое значение boolean из строки в boolean
     * Если значение имеет тип отличный от строки 'true' | 'false', то никаких изменений не вносится
     * @param value - Преобразуемое значение
     * @returns Преобразованное значение
     */
    sanitizeBooleanStringToBoolean(value) {
        if (value === 'true') {
            return true;
        }
        if (value === 'false') {
            return false;
        }
        return value;
    }
};
FilterService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Calendar])
], FilterService);
export { FilterService };
